// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"SearchElement_searchContainer__ueyR9","searchBox":"SearchElement_searchBox__p_msL","searchArea":"SearchElement_searchArea__LYOF_"};